import { doc, updateDoc } from 'firebase/firestore';
import { Scavenger, Step } from '../../Scavenger/types';
import { SCAVENGER_COLLECTION } from '../constants';

export const updateScavenger = async (scavenger: Scavenger, newStep: Step) => {
  return await updateDoc(doc(SCAVENGER_COLLECTION, scavenger.id), {
    // @ts-expect-error
    current_step: newStep,
  });
};
